import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    fieldsWineCellarPose,
    fieldsWineNbDoor,
    fieldsWineCellarDoor,
    fieldsWineDoorSens,
    fieldsWineCellarShelf,
    fieldsShelfMaterial,
    fieldsWineCellarOption,
    fieldsWineNbBootle,
    fieldsWineCellarDimension,
    fieldsWineCellarMultiSelector,
} from './common/fieldsWineCellar';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const WineCellarForm: IForm = {
    formId       : PublishedFormId.WineCellar,
    type         : FormTypeId.WineCellar,
    thumbnailURL : '/resized-images/forms/wineCellar.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.MultiSelector,
        IFormFieldKey.WineCellarPose,
        IFormFieldKey.Dimension,
        IFormFieldKey.WineCellarNbDoor,
        IFormFieldKey.WineCellarDoor,
        IFormFieldKey.WineCellarSensDoor,
        IFormFieldKey.WineCellarShelf,
        IFormFieldKey.WineCellarShelfMaterial,
        IFormFieldKey.WineCellarNbBottle,
        IFormFieldKey.AddOns,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        multiSelector           : fieldsWineCellarMultiSelector,
        wineCellarPose          : fieldsWineCellarPose,
        wineCellarNbDoor        : fieldsWineNbDoor,
        dimension               : fieldsWineCellarDimension,
        wineCellarDoor          : fieldsWineCellarDoor,
        wineCellarSensDoor      : fieldsWineDoorSens,
        wineCellarShelf         : fieldsWineCellarShelf,
        wineCellarShelfMaterial : fieldsShelfMaterial,
        wineCellarNbBottle      : fieldsWineNbBootle,
        addOns                  : fieldsWineCellarOption,
        additionalData          : additionalDataFactory({
            budgetMin          : 1000,
            budgetMax          : 20000,
            budgetDefaultValue : 4500,
            marks              : budgetMarksBuilder(1000, 100, 10000, 500, 20000),
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default WineCellarForm;
